import _extends from "@babel/runtime/helpers/extends";
function overrideStyles(base, overrides) {
  if (!overrides) {
    return base;
  }
  const merged = _extends({}, base);
  Object.keys(overrides).forEach(key => {
    merged[key] += ` ${overrides[key]}`;
  });
  return merged;
}
export default overrideStyles;